import { render, staticRenderFns } from "./ProfileFinishAttention.vue?vue&type=template&id=1fe1494e&scoped=true&"
import script from "./ProfileFinishAttention.vue?vue&type=script&lang=js&"
export * from "./ProfileFinishAttention.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFinishAttention.vue?vue&type=style&index=0&id=1fe1494e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe1494e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1fe1494e', component.options)
    } else {
      api.reload('1fe1494e', component.options)
    }
    module.hot.accept("./ProfileFinishAttention.vue?vue&type=template&id=1fe1494e&scoped=true&", function () {
      api.rerender('1fe1494e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/finish_attention/ProfileFinishAttention.vue"
export default component.exports